<template>
  <div data-test-id="SimpleSpinner" aria-live="polite" aria-busy="true" class="simple-spinner" />
</template>

<style lang="postcss">
.simple-spinner {
  width: 3rem;
  border: 5px solid #fff;
  border-radius: 50%;
  border-bottom-color: transparent;
  animation: rotation 0.6s linear infinite;
  aspect-ratio: 1 / 1;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
